export const translations = {
  en: {
    title: 'Personal Information',
    paragraph_text:
      'The information you provide is used to locate your Intermountain record and contact you with test results. We will send a one-time passcode to your phone number for verification. If you do not have a cell phone, a one-time passcode will be sent to your email address. Your mobile phone, email address and insurance will be updated. Contact us at 385-297-6430 if updates are needed to your physical/mailing address.',
    paragraph_text2:
      'If you change your cell phone number, we will send a one-time passcode to your phone for verification.',
    no_special_char: 'No numbers or special characters or space allowed',
    field_1: 'Legal first name',
    field_1_err_1: 'Please use 16 characters or less',
    field_1_err_2: 'Please enter a valid first name',
    field_2: 'Legal middle name',
    field_2_err_1: 'Please use 16 characters or less',
    field_3: 'Legal last name',
    field_3_err_1: 'Please use 26 characters or less',
    field_3_err_2: 'Please enter a valid last name',
    field_4: 'Date of birth',
    field_4_placeholder: 'MM/DD/YYYY',
    field_4_err_1:
      'If your child is less than 3 months old and having symptoms, call your pediatrician or visit an Intermountain InstaCare/KidsCare for evaluation.',
    field_4_err_2: 'Invalid date format',
    field_4_err_3: 'Must be exactly 8 digits',
    field_4_err_4: 'Please enter a valid date of birth',
    field_4_err_5: 'Please enter a valid date',
    field_5: 'Sex',
    field_5_err_1: 'Please select a gender',
    field_5_tooltip:
      'This is the legal sex marker on your insurance/health record/drivers license, which may differ from your current gender identity.',
    field_6: 'Last four digits of SSN',
    field_6_err_1: 'Please enter valid number',
    field_7: 'Address line 1',
    field_7_err_1: 'Please use 30 characters or less',
    field_7_err_2: 'Please enter line 1 of your address',
    field_8: 'Address line 2',
    field_8_err_1: 'Please use 30 characters or less',
    field_9: 'City',
    field_9_err_1: 'Please use 34 characters or less',
    field_9_err_2: 'Please enter a city',
    field_10: 'State',
    field_10_err_1: 'Please select a valid State',
    field_11: 'Zip code',
    field_11_err_1: 'Please enter a valid zip code',
    field_11_err_2: 'Must be a valid zip',
    field_12: 'Email',
    field_12_err_1: 'Please enter a valid email address',
    field_12_err_2: 'Please enter a valid email',
    field_13: 'Cell phone number',
    field_13_err_1: 'Please enter a valid number',
    field_13_err_2: 'Must be exactly 10 digits',
    checkbox: 'I don’t have a cell phone number.',
    field_14: 'Alternate phone number',
    field_14_err_1: 'Please enter a valid number',
    field_14_err_2: 'Must be exactly 10 digits',
    MALE: 'Male',
    FEMALE: 'Female',
    UNKNOWN: 'Unknown',
    BOTH: 'Both',
    COVID_SCREENING_PERSONAL_INFO_BODY_1:
      'The information you provide is used to locate your Intermountain record and ',
    COVID_SCREENING_PERSONAL_INFO_BODY_2_OTP: `. We will send a one-time passcode to your phone number for verification. `,
    COVID_SCREENING_PERSONAL_INFO_BODY_2: `contact you with test results`,
    COVID_SCREENING_PERSONAL_INFO_BODY_3B_OTP: `If you do not have a cell phone, a one-time passcode will be sent to your email address. Your mobile phone, email address and insurance will be updated. Contact us at 385-297-6430 if updates are needed to your physical/mailing address.`,
    OTP_PHONE_TITLE: 'Phone Number Verification',
    OTP_EMAIL_TITLE: 'Email Verification',
    OTP_NOT_RECEIVE: 'Did not receive code?',
    OTP_RECEIVE: 'Enter the one-time passcode code sent to',
    OTP_PROCEED: 'to proceed.',
    OTP_PHONE_VERIFY: 'Phone number verified.',
    OTP_EMAIL_VERIFY: 'Email verified.',
    OTP_INCORRECT: 'Incorrect code. Please try again.',
    OTP_PHONE_ERROR: 'We could not validate the phone number',
    OTP_EMAIL_ERROR_1: 'We could not validate the email',
    OTP_EMAIL_ERROR_2: '. Please verify you entered your email correctly.',
    OTP_PHONE_ERROR_1: 'We could not send a one-time passcode to ',
    OTP_PHONE_ERROR_2: '. Please verify you entered your phone number correctly.',
    OTP_MAX_PIN_UNAUTH_ERROR:
      'The one-time passcode limit has been reached with this session. Please wait 15 minutes, and try again.',
    OTP_OTHER_ERROR: 'A one-time passcode error occurred, please try again.'
  },
  es: {
    title: 'Información personal',
    paragraph_text:
      'La información que provee se utiliza para localizar su registro de Intermountain y contactarlo con los resultados de la prueba. Le enviaremos un código de acceso único a su número de teléfono para su verificación. Si no tiene un teléfono celular, se le enviará un código de acceso único a su dirección de correo electrónico. Se actualizarán su teléfono celular, su dirección de correo electrónico y su seguro. Póngase en contacto con nosotros al 385-297-6430 si es necesario actualizar su dirección física o de correo.',
    paragraph_text2:
      'Si cambia su número de teléfono celular, le enviaremos una clave de acceso única de verificación.',
    no_special_char: 'Números, carácteres especiales o espacios no son permitidos.',
    field_1: 'Primer nombre legal',
    field_1_err_1: 'Por favor use 16 caracteres o menos',
    field_1_err_2: 'Por favor introduzca un primer nombre válido',
    field_2: 'Segundo nombre legal',
    field_2_err_1: 'Por favor use 16 caracteres o menos',
    field_3: 'Apellido legal',
    field_3_err_1: 'Por favor use 26 caracteres o menos',
    field_3_err_2: 'Por favor introduzca un apellido válido',
    field_4: 'Fecha de nacimiento',
    field_4_placeholder: 'MM/DD/AAAA',
    field_4_err_1:
      'Si su hijo es menor de 3 meses de edad y tiene síntomas, llame a su pediatra o a Intermountain InstaCare/KidsCare para que lo evalúen.',
    field_4_err_2: 'Formato de fecha inválido',
    field_4_err_3: 'Debe ser exactamente 8 dígitos',
    field_4_err_4: 'Por favor introduzca fecha de nacimiento válida',
    field_4_err_5: 'Por favor introduzca una fecha valida',
    field_5: 'Sexo',
    field_5_err_1: 'Por favor seleccione un género',
    field_5_tooltip:
      'Esta es la identificación legal de sexo que se encuentra en su licencia de conducir, registros médicos o de seguro, la cual puede ser diferente a su identidad sexual actual.',
    field_6: 'Últimos cuatro dígitos del SSN',
    field_6_err_1: 'Por favor ingrese un número válido',
    field_7: 'Dirección 1',
    field_7_err_1: 'Por favor use 30 caracteres o menos',
    field_7_err_2: 'Por favor introduzca la primera calle de su dirección',
    field_8: 'Dirección 2',
    field_8_err_1: 'Por favor use 30 caracteres o menos',
    field_9: 'Ciudad',
    field_9_err_1: 'Por favor use 34 caracteres o menos',
    field_9_err_2: 'Por favor introduzca la ciudad',
    field_10: 'Estado',
    field_10_err_1: 'Por favor seleccione un estado válido',
    field_11: 'Código postal',
    field_11_err_1: 'Por favor introduzca código zip válido',
    field_11_err_2: 'Debe ser un zip válido',
    field_12: 'Email',
    field_12_err_1: 'Por favor introduzca un email válido',
    field_12_err_2: 'Por favor introduzca un email válido',
    field_13: 'Número de teléfono celular',
    field_13_err_1: 'Por favor introduzca un numero válido',
    field_13_err_2: 'Debe ser exactamente 10 dígitos',
    checkbox: 'No tengo un número de teléfono celular.',
    field_14: 'Número de teléfono alternativo',
    field_14_err_1: 'Por favor introduzca un numero válido',
    field_14_err_2: 'Debe ser exactamente 10 dígitos',
    MALE: 'Masculino',
    FEMALE: 'Femenino',
    UNKNOWN: 'No sé',
    BOTH: 'Ambos',
    COVID_SCREENING_PERSONAL_INFO_BODY_1:
      'La información que provee se utiliza para localizar su registro de Intermountain y',
    COVID_SCREENING_PERSONAL_INFO_BODY_2_OTP: ` Le enviaremos un código de acceso único a su número de teléfono para su verificación. Si no tiene un teléfono celular, se le enviará un código de acceso único a su dirección de correo electrónico.`,
    COVID_SCREENING_PERSONAL_INFO_BODY_2: ` contactarlo con los resultados de la prueba.`,
    COVID_SCREENING_PERSONAL_INFO_BODY_3B_OTP: ` Se actualizarán su teléfono celular, su dirección de correo electrónico y su seguro. Póngase en contacto con nosotros al 385-297-6430 si es necesario actualizar su dirección física o de correo.`,
    OTP_PHONE_TITLE: 'Verificación del número de teléfono',
    OTP_EMAIL_TITLE: 'Verificación del correo electrónico',
    OTP_NOT_RECEIVE: '¿No ha recibido el código?',
    OTP_RECEIVE: 'Introduzca el código enviado a',
    OTP_PROCEED: 'para continuar.',
    OTP_PHONE_VERIFY: 'Número de teléfono verificado.',
    OTP_EMAIL_VERIFY: 'Correo electrónico verificado.',
    OTP_INCORRECT: 'Código incorrecto. Inténtelo de nuevo.',
    OTP_PHONE_ERROR: 'No hemos podido validar el número de teléfono',
    OTP_EMAIL_ERROR_1: 'No hemos podido validar el correo electrónico ',
    OTP_EMAIL_ERROR_2: '. Verifique que ha introducido su correo electrónico correctamente.',
    OTP_PHONE_ERROR_1: 'No hemos podido enviar un código de acceso único a ',
    OTP_PHONE_ERROR_2: '. Verifique que ha introducido su número de teléfono correctamente.',
    OTP_MAX_PIN_UNAUTH_ERROR:
      'Se ha alcanzado el límite de una clave de acceso con esta sesión. Favor de esperar 15 minutos y inténtelo de nuevo.',
    OTP_OTHER_ERROR: ' Ocurrió un error de código de acceso único. Por favor, inténtelo de nuevo.'
  }
};
